module.exports = __webpack_public_path__ + "static/description-icon-33f1cb7f9f1212a967300795fda633f9.png";